//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {jFunc} from "../../js/jfunctions.min";

export default {
  name: "v-dedicated-solutions-filter",
  model : {
    prop: 'model',
    event: 'change'
  },
  data() {
    return {
      selected : {
        PRICE : [0,0],
        CPU : [],
        CPU_FREQUENCY : [0,0],
        CPU_CORE : [],
        RAM : [],
        HDD_TYPE : [],
        HDD_COUNT : [],
      },
      // what properties need read as range
      rangeProperties : ['PRICE', 'CPU_FREQUENCY'],
      rangeDivides : {
        PRICE : [0,0],
        CPU_FREQUENCY : [0,0],
      },
      fakeRanges : {
        PRICE : [0,0],
        CPU_FREQUENCY : [0,0],
      },
      rangeSelectors : {
        PRICE : '.dedicated-solutions-filter-range.price',
        CPU_FREQUENCY : '.dedicated-solutions-filter-range.cpu_freequency',
      },
      filterSelectedItems : [],
    };
  },
  props : ['components', 'items'],
  methods : {
    getSorted(obj, field = 'SORT', direction = 'ASC') {
      return jFunc.sortArrayOfObjectsByKeyValue(obj, field, direction);
    },
    getNumeral(count, words, withNumber = true) {
      return (withNumber ? count + ' ' : '') + jFunc.getNumeral(count, words)
    },
    setRange(code, index, value, updateRange = false) {
      let self = this;
      value = +value;
      if(jFunc.typeof(value) != 'NaN')
      {
        if(value >= self.rangeDivides[code][0] && value <= self.rangeDivides[code][1]) {

          self.$set(self.$data.selected[code], index, value);

          let anotherDivideIndex = +!index;

          switch(anotherDivideIndex) {
            case 0:
              if(self.selected[code][index] > value)
                self.$set(self.$data.selected[code], 0, value);
              break;
            case 1:
              if(self.selected[code][index] < value)
                self.$set(self.$data.selected[code], 1, value);
              break;
          }

          if(updateRange) {
            $( self.rangeSelectors[code] ).slider( "option", "values", self.selected[code] );
          }
        }
      }

      self.$set(self.$data.fakeRanges[code], 0, self.$data.selected[code][0]);
      self.$set(self.$data.fakeRanges[code], 1, self.$data.selected[code][1]);
    },
    getFilterSelectedItems() {
      let self = this;
      let result = [];

      for(let propertyKey in self.selected) {
          let currentValues = self.selected[propertyKey];
          let resultItem = {
            'CODE' : propertyKey,
            'NAME' : '',
          };
          if(self.rangeProperties.indexOf(propertyKey) > -1) {
            if(currentValues[0] != self.rangeDivides[propertyKey][0] || currentValues[1] != self.rangeDivides[propertyKey][1]) {
              resultItem.NAME = 'от ' + currentValues[0] + ' до ' + currentValues[1];
              resultItem.delete = function() {
                self.setRange(propertyKey, 0, self.rangeDivides[propertyKey][0], true);
                self.setRange(propertyKey, 1, self.rangeDivides[propertyKey][1], true);
              };
            }
          }
          else {
            if(typeof currentValues == 'object' && currentValues.length) {
              let propertyNameParts = [];

              currentValues.forEach(function(value) {
                result.push({
                  'CODE' : propertyKey + '_' + value,
                  'NAME' : jFunc.getNested(self.components, propertyKey, value, 'NAME') || value,
                  'delete' : function() {
                    self.$data.selected[propertyKey].forEach(function(item, index) {
                      if(item == value)
                        self.$delete(self.$data.selected[propertyKey], index);
                    });
                  }
                });
              });


              // currentValues.forEach(function(value) {
              //   propertyNameParts.push(jFunc.getNested(self.components, propertyKey, value, 'NAME') || value);
              // });
              //
              // if(propertyNameParts.length) {
              //   resultItem.NAME = propertyNameParts.join(', ');
              // }
              //
              // resultItem.delete = function() {
              //   self.$set(self.$data.selected, propertyKey, []);
              //   self.$delete(self.$data.selected[propertyKey]);
              // };
            }
          }

          if(resultItem.NAME.length)
            result.push(resultItem);
      }

      if(result.length)
        result.push({
          'CODE' : 'CLEAR_ALL',
          'NAME' : 'Сбросить все',
          'delete' : function () {
            result.forEach(function(item) {
              if(typeof item.delete == 'function' && item.CODE != 'CLEAR_ALL')
                item.delete();
            });
          },
        });

      return result;
    },
  },
  computed : {
    /**
     * values for CPU filtering
     * @returns {{CORE: *[], FREEQUENCY: number[]}}
     */
    cpuValues() {
      let self = this;
      let result = {
        FREEQUENCY : [99999999999999, 0], // defaults for compare with min and max values
        CORE : [],
      };

      for(let cpuId in self.components.CPU) {
          let current = self.components.CPU[cpuId];

          // set max frequency
          if(+current.PROPERTIES.CLOCK_FREQUENCY.VALUE > result.FREEQUENCY[1]) {
            result.FREEQUENCY[1] = +current.PROPERTIES.CLOCK_FREQUENCY.VALUE;
          }
          // set min frequency
          if(+current.PROPERTIES.CLOCK_FREQUENCY.VALUE < result.FREEQUENCY[0]) {
            result.FREEQUENCY[0] = +current.PROPERTIES.CLOCK_FREQUENCY.VALUE;
          }
          // set cores count
          if(result.CORE.indexOf(+current.PROPERTIES.CORE.VALUE) == -1) {
            result.CORE.push(+current.PROPERTIES.CORE.VALUE);
          }
      }

      result.CORE.sort(function(a,b) {
        return a - b;
      });

      return result;
    },
    /**
     * values for RAM filtering
     * @returns {{MEMORY: *[]}}
     */
    ramValues() {
      let self = this;
      let result = {
        MEMORY : [],
      };

      for(let ramId in self.components.RAM) {
          let current = self.components.RAM[ramId];

          // set memory value
          if(result.MEMORY.indexOf(+current.PROPERTIES.MEMORY.VALUE) == -1) {
            result.MEMORY.push(+current.PROPERTIES.MEMORY.VALUE);
          }
      }

      result.MEMORY.sort(function(a,b) {
        return a - b;
      });

      return result;
    },
    /**
     * disk types for filtering
     * @returns {*[]}
     */
    diskTypes() {
      let self = this;
      let result = [];
      let sortMap = {};

      for(let hddId in self.components.HDD) {
          let current = self.components.HDD[hddId];

        if(result.indexOf(current.PROPERTIES.TYPE.VALUE) == -1) {
          result.push(current.PROPERTIES.TYPE.VALUE);
          sortMap[current.PROPERTIES.TYPE.VALUE] = current.PROPERTIES.TYPE.VALUE_SORT;
        }
      }

      result.sort(function(a, b) {
        return sortMap[a] - sortMap[b];
      });

      return result;
    },
    hddCountVariants() {
      let self = this;
      let result = [];

      for(let hddId in self.components.HDD_COUNT) {
          let currentCount = self.components.HDD_COUNT[hddId];

          if(result.indexOf(+currentCount) == -1)
            result.push(+currentCount)
      }
      result.sort(function(a,b) {
        return a - b;
      });

      return result;
    },
    /**
     * values of items for filtering
     * @returns {{}}
     */
    itemsValues() {
      let self = this;
      let result = {};

      for(let itemId in self.items) {
          let current = self.items[itemId];
          let currentCpu = self.components.CPU[current.PROPERTIES.CPU.VALUE];

          result[current.ID] = {
            'PRICE' : current.PRICES.BASE.DISCOUNT_VALUE,
            'CPU' : current.PROPERTIES.CPU.VALUE,
            'CPU_FREQUENCY' : !!currentCpu ? +currentCpu.PROPERTIES.CLOCK_FREQUENCY.VALUE : 0,
            'CPU_CORE' : !!currentCpu ? +currentCpu.PROPERTIES.CORE.VALUE : 0,
            'RAM' : +self.components.RAM[current.PROPERTIES.RAM.VALUE].PROPERTIES.MEMORY.VALUE,
            'HDD_TYPE' : [], // will be filled later
            'HDD_COUNT' : +current.PROPERTIES.HDD_COUNT.VALUE,
          };

          // HDD_COUNT filling
          for(let index in current.PROPERTIES.DISKS.VALUE) {
              let hddId = current.PROPERTIES.DISKS.VALUE[index];

              let type = self.components.HDD[hddId].PROPERTIES.TYPE.VALUE;

              if(result[current.ID]['HDD_TYPE'].indexOf(type) == -1)
                result[current.ID]['HDD_TYPE'].push(type);
          }
      }

      return result;
    },
  },
  mounted() {
    let self = this;
    let createRange = function (selector, minValue, maxValue, step, startValue, callback = false) {
      $(selector).slider({
        range: true,
        min: minValue,
        max: maxValue,
        step: step,
        values: startValue,
        create: function () {
          let self = $(this),
              minValue = self.slider('option', 'min'),
              maxValue = self.slider('option', 'max'),
              valuesElements = self.closest('.dedicated-solutions-filter-block-range').find('.dedicated-solutions-filter-range-values'),
              minElement = $($(valuesElements).find('.dedicated-solutions-filter-range-min')[0]),
              maxElement = $($(valuesElements).find('.dedicated-solutions-filter-range-max')[1]);
          $(minElement).text(minValue);
          $(maxElement).text(maxValue);
          self.find('.ui-slider-handle').append('<span class="build-server-range-value"></span>');
        },
        start: function (event, ui) {
          let self = $(this),
              valueElement = self.closest('.dedicated-solutions-filter-block-range').find('.build-server-range-value'),
              valuesElement = self.closest('.dedicated-solutions-filter-block-range').find('.dedicated-solutions-filter-range-values');
          valueElement.text(ui.value);
          valueElement.addClass('active');
          valuesElement.addClass('hidden');
        },
        slide: function (event, ui) {
          let self = $(this),
              valueElement = self.closest('.dedicated-solutions-filter-block-range').find('.build-server-range-value');
          $(valueElement[0]).text(ui.values[0]);
          $(valueElement[1]).text(ui.values[1]);

          if(typeof callback == 'function') {
            callback(ui.values);
          }
        },
        stop: function () {
          let self = $(this),
              valueElement = self.closest('.dedicated-solutions-filter-block-range').find('.build-server-range-value'),
              valuesElement = self.closest('.dedicated-solutions-filter-block-range').find('.dedicated-solutions-filter-range-values');
          valuesElement.removeClass('hidden');
          if (valueElement.text() > self.slider('option', 'min') && valueElement.text() < self.slider('option', 'max')) {
            return;
          } else {
            valueElement.removeClass('active');
          }
        }
      });
    };
    let ranges = {
      PRICE : [999999, 0],
      CPU_FREQUENCY : [999999, 0],
    };

    // set max and min ranges values
    for(let itemId in self.itemsValues) {
        let current = self.itemsValues[itemId];

        Object.keys(ranges).forEach(function(propertyCode) {
          if(current[propertyCode] < ranges[propertyCode][0]) {
            ranges[propertyCode][0] = +current[propertyCode];
          }
          if(current[propertyCode] > ranges[propertyCode][1]) {
            ranges[propertyCode][1] = +current[propertyCode];
          }
        });
    }

    // set real values
    self.$set(self.$data.selected, 'PRICE', [ranges.PRICE[0], ranges.PRICE[1]]);
    self.$set(self.$data.selected, 'CPU_FREQUENCY', [ranges.CPU_FREQUENCY[0], ranges.CPU_FREQUENCY[1]]);
    // set fake values for input validating
    self.$set(self.$data.fakeRanges, 'PRICE', [ranges.PRICE[0], ranges.PRICE[1]]);
    self.$set(self.$data.fakeRanges, 'CPU_FREQUENCY', [ranges.CPU_FREQUENCY[0], ranges.CPU_FREQUENCY[1]]);
    // set divides of ranges
    self.$set(self.$data.rangeDivides, 'PRICE', [ranges.PRICE[0], ranges.PRICE[1]]);
    self.$set(self.$data.rangeDivides, 'CPU_FREQUENCY', [ranges.CPU_FREQUENCY[0], ranges.CPU_FREQUENCY[1]]);

    createRange('.dedicated-solutions-filter-range.price',
        ranges.PRICE[0],
        ranges.PRICE[1],
        1,
        [ranges.PRICE[0], ranges.PRICE[1]],
        function(value) {
          // self.$set(self.$data.selected, 'PRICE', value);

          self.setRange('PRICE', 0, value[0]);
          self.setRange('PRICE', 1, value[1]);
        });
    createRange('.dedicated-solutions-filter-range.cpu_freequency',
        ranges.CPU_FREQUENCY[0],
        ranges.CPU_FREQUENCY[1],
        0.1,
        [ranges.CPU_FREQUENCY[0], ranges.CPU_FREQUENCY[1]],
        function(value) {
          // self.$set(self.$data.selected, 'CPU_FREQUENCY', value);

          self.setRange('CPU_FREQUENCY', 0, value[0]);
          self.setRange('CPU_FREQUENCY', 1, value[1]);
        }
    );
    $('.dedicated-solutions-filter-range').draggable();
  },
  watch: {
    selected: {
      handler(val){
        let self = this;
        let result = [];
        // for each items
        for(let itemId in self.itemsValues) {
            let currentItem = self.itemsValues[itemId];
            let itemResult = true; // item filtering result (success flag)
            // for each selected filter values
            for(let propertyCode in self.selected) {
                let currentValue = self.selected[propertyCode];
                let currentResult = false; // property comparison result (success flag)

                if(!currentValue || ( typeof currentValue == 'object' && !Object.keys(currentValue).length ) )
                  continue;

                if(typeof currentValue != 'object') {
                  currentValue = [currentValue];
                }

                // if selected value is range
                if(self.rangeProperties.indexOf(propertyCode) > -1) {
                  currentResult = (currentItem[propertyCode] >= currentValue[0] && currentItem[propertyCode] <= currentValue[1]);
                }
                else {
                  currentValue.forEach(function(value) {
                    if(typeof currentItem[propertyCode] == 'object') {
                      currentResult = currentResult || ( currentItem[propertyCode].indexOf(value) > -1 );
                    }
                    else {
                      currentResult = currentResult || ( currentItem[propertyCode] == value );
                    }
                  });
                }


                itemResult = itemResult && currentResult;
            }

            if(itemResult) {
              result.push(itemId);
            }
        }

        self.$set(self.$data, 'filterSelectedItems', self.getFilterSelectedItems());

        // console.log(result);
        self.$emit('change', result);
      },
      deep: true
    }
  },
}



// WEBPACK FOOTER //
// ./depohost.ru/local/vue.js/v-dedicated-solutions-filter/v-dedicated-solutions-filter.vue